<template>
    <div>
        <v-card solo flat>
            <v-card-title>
                <v-spacer />
                <v-btn color="primary" @click="openDialog">Add Model</v-btn>
            </v-card-title>
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="models"
                    class="elevation-1"
                    :loading="loading"
                >
                    <template v-slot:[`item.file`]="{ item }">
                        <span
                            style="text-decoration: underline; color: blue; cursor: pointer;"
                            @click="openModelFile(item)"
                            >{{ item.file.name }}</span
                        >
                    </template>
                    <template v-slot:[`item.doubleAngle`]="{ item }">
                        <span
                            v-if="item.name === '5LS-H' && item.doubleAngleFile"
                            style="text-decoration: underline; color: blue; cursor: pointer;"
                            @click="openFileByType(item, 'double_angle')"
                            >{{ item.doubleAngleFile.name }}</span
                        >
                        <span v-else-if="item.name === '5LS-H'">No file</span>
                        <span v-else>-</span>
                    </template>
                    <template v-slot:[`item.fpaFile`]="{ item }">
                        <span
                            v-if="item.fpaFile"
                            style="text-decoration: underline; color: blue; cursor: pointer;"
                            @click="openFileByType(item, 'fpa')"
                            >{{ item.fpaFile.name }}</span
                        >
                        <span v-else>-</span>
                    </template>
                    <template v-slot:[`item.cadFile`]="{ item }">
                        <span
                            v-if="item.cadFile"
                            style="text-decoration: underline; color: blue; cursor: pointer;"
                            @click="openFileByType(item, 'cad')"
                            >{{ item.cadFile.name }}</span
                        >
                        <span v-else>-</span>
                    </template>
                    <template v-slot:[`item.specsFile`]="{ item }">
                        <span
                            v-if="item.specsFile"
                            style="text-decoration: underline; color: blue; cursor: pointer;"
                            @click="openFileByType(item, 'specs')"
                            >{{ item.specsFile.name }}</span
                        >
                        <span v-else>-</span>
                    </template>
                    <template v-slot:[`item.installationManualFile`]="{ item }">
                        <span
                            v-if="item.installationManualFile"
                            style="text-decoration: underline; color: blue; cursor: pointer;"
                            @click="openFileByType(item, 'installation_manual')"
                            >{{ item.installationManualFile.name }}</span
                        >
                        <span v-else>-</span>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <div class="d-flex justify-center">
                            <v-btn icon @click="editModel(item)">
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn icon @click="deleteModel(item)">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </div>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <v-dialog v-model="dialog" max-width="400px">
            <v-card :loading="loading">
                <v-card-title>{{
                    editMode ? 'Edit Model' : 'Add Model'
                }}</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-select
                                v-model="model.name"
                                label="Name"
                                :rules="[rules.required]"
                                required
                                prepend-icon="mdi-text-box-outline"
                                :items="types"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-file-input
                                label="File"
                                v-model="modelFile"
                                prepend-icon="mdi-upload"
                                :clearable="false"
                            ></v-file-input>
                        </v-col>
                    </v-row>
                    <!-- Double angle -->
                    <v-row v-if="model.name === '5LS-H'">
                        <v-col cols="12">
                            <v-file-input
                                label="Doble Angulo File"
                                v-model="doubleAngleFile"
                                prepend-icon="mdi-angle-acute"
                                :clearable="false"
                            ></v-file-input>
                        </v-col>
                    </v-row>
                    <!-- FPA -->
                    <v-row>
                        <v-col cols="12">
                            <v-file-input
                                label="FPA File"
                                v-model="fpaFile"
                                prepend-icon="mdi-angle-acute"
                                :clearable="false"
                            ></v-file-input>
                        </v-col>
                    </v-row>
                    <!-- CAD -->
                    <v-row>
                        <v-col cols="12">
                            <v-file-input
                                label="CAD File"
                                v-model="cadFile"
                                prepend-icon="mdi-angle-acute"
                                :clearable="false"
                            ></v-file-input>
                        </v-col>
                    </v-row>
                    <!-- SPECS -->
                    <v-row>
                        <v-col cols="12">
                            <v-file-input
                                label="SPECS File"
                                v-model="specsFile"
                                prepend-icon="mdi-angle-acute"
                                :clearable="false"
                            ></v-file-input>
                        </v-col>
                    </v-row>
                    <!-- Installation Manual -->
                    <v-row>
                        <v-col cols="12">
                            <v-file-input
                                label="Installation Manual File"
                                v-model="installationManualFile"
                                prepend-icon="mdi-file-document-outline"
                                :clearable="false"
                            ></v-file-input>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="closeDialog" color="red">Cancel</v-btn>
                    <v-btn color="primary" @click="saveModel" :loading="loading"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { v4 as uuidv4 } from 'uuid'
import { mapMutations } from 'vuex'
import { saveFile } from '@/services/storage/saveFile.js'
import API from '@/services/api'
import { deleteFile } from '@/services/storage/deleteFile.js'
import { storage } from '@/services/firebase'
import _ from 'lodash'

export default {
    name: 'Datasheets',
    props: {
        setting: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        loading: false,
        headers: [
            { text: 'Name', value: 'name', sortable: false },
            { text: 'File', value: 'file', sortable: false },
            { text: 'Doble Angulo', value: 'doubleAngle', sortable: false },
            { text: 'FPA', value: 'fpaFile', sortable: false },
            { text: 'CAD', value: 'cadFile', sortable: false },
            { text: 'SPECS', value: 'specsFile', sortable: false },
            {
                text: 'Installation Manual',
                value: 'installationManualFile',
                sortable: false,
            },
            {
                text: 'Actions',
                value: 'actions',
                sortable: false,
                width: '100px',
                align: 'center',
            },
        ],
        models: [],
        model: {},
        dialog: false,
        editMode: false,
        rules: {
            required: v => !!v || 'The value is required',
        },
        types: [
            '5LS-H',
            '5LS-V',
            '1.4LS-42',
            '1.4LS-42-HP',
            '1.4LS-60',
            '1.8LS-H',
            '3LS-V',
            '5LS-HV',
        ],
        companyId: JSON.parse(localStorage.getItem('company')),
        modelFile: null,
        doubleAngleFile: null,
        fpaFile: null,
        cadFile: null,
        specsFile: null,
        installationManualFile: null,
    }),
    async mounted() {
        try {
            this.loading = true
            await this.getModels()
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        // Helper method to safely extract file extension
        getFileExtension(filename) {
            if (!filename) return ''
            const lastDot = filename.lastIndexOf('.')
            return lastDot !== -1 ? filename.substring(lastDot) : ''
        },
        async createFiles() {
            const basePath = `${this.companyId}/settings/client_portal/models/${this.model.name}`
            const files = {}

            // Double angle file
            if (this.doubleAngleFile) {
                const ext = this.getFileExtension(this.doubleAngleFile.name)
                files.doubleAngleFile = {
                    id: uuidv4() + ext,
                    name: this.doubleAngleFile.name,
                }
                await saveFile(
                    this.doubleAngleFile,
                    `${basePath}/double_angle`,
                    files.doubleAngleFile.id
                )
            }

            // FPA file
            if (this.fpaFile) {
                const ext = this.getFileExtension(this.fpaFile.name)
                files.fpaFile = {
                    id: uuidv4() + ext,
                    name: this.fpaFile.name,
                }
                await saveFile(
                    this.fpaFile,
                    `${basePath}/fpa`,
                    files.fpaFile.id
                )
            }

            // CAD file
            if (this.cadFile) {
                const ext = this.getFileExtension(this.cadFile.name)
                files.cadFile = {
                    id: uuidv4() + ext,
                    name: this.cadFile.name,
                }
                await saveFile(
                    this.cadFile,
                    `${basePath}/cad`,
                    files.cadFile.id
                )
            }

            // SPECS file
            if (this.specsFile) {
                const ext = this.getFileExtension(this.specsFile.name)
                files.specsFile = {
                    id: uuidv4() + ext,
                    name: this.specsFile.name,
                }
                await saveFile(
                    this.specsFile,
                    `${basePath}/specs`,
                    files.specsFile.id
                )
            }

            // Installation Manual file
            if (this.installationManualFile) {
                const ext = this.getFileExtension(
                    this.installationManualFile.name
                )
                files.installationManualFile = {
                    id: uuidv4() + ext,
                    name: this.installationManualFile.name,
                }
                await saveFile(
                    this.installationManualFile,
                    `${basePath}/installation_manual`,
                    files.installationManualFile.id
                )
            }

            return files
        },
        editModel(item) {
            this.model = _.cloneDeep(item)
            this.editMode = true
            this.dialog = true
        },
        async deleteModel(item) {
            try {
                this.loading = true
                await deleteFile(
                    item.file.id,
                    `${this.companyId}/settings/client_portal/models/${item.name}`
                )
                await API.deleteModel({
                    settingId: this.setting.id,
                    id: item.id,
                })
                this.models = this.models.filter(m => m.id != item.id)
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        openDialog() {
            this.dialog = true
        },
        closeDialog() {
            this.dialog = false
            this.editMode = false
        },
        async saveModel() {
            try {
                this.loading = true
                if (this.editMode) {
                    let file = undefined
                    if (this.modelFile) {
                        const ext = this.getFileExtension(this.modelFile.name)
                        file = {
                            id: uuidv4() + ext,
                            name: this.modelFile.name,
                        }
                        // save file in firebase storage
                        await saveFile(
                            this.modelFile,
                            `${this.companyId}/settings/client_portal/models/${this.model.name}`,
                            file.id
                        )
                    }
                    const {
                        doubleAngleFile,
                        fpaFile,
                        cadFile,
                        specsFile,
                        installationManualFile,
                    } = await this.createFiles()
                    // save in db
                    const updatedModel = await API.updateModel({
                        settingId: this.setting.id,
                        id: this.model.id,
                        name: this.model.name,
                        ...(file ? { file } : {}),
                        ...(doubleAngleFile ? { doubleAngleFile } : {}),
                        ...(fpaFile ? { fpaFile } : {}),
                        ...(cadFile ? { cadFile } : {}),
                        ...(specsFile ? { specsFile } : {}),
                        ...(installationManualFile
                            ? { installationManualFile }
                            : {}),
                    })
                    const index = this.models.findIndex(
                        item => item.id == this.model.id
                    )
                    this.$set(this.models, index, {
                        ...this.models[index],
                        ...updatedModel,
                    })
                } else {
                    if (this.models.some(m => m.name == this.model.name)) {
                        throw new Error('The model already exists')
                    }
                    const ext = this.getFileExtension(this.modelFile.name)
                    const file = {
                        id: uuidv4() + ext,
                        name: this.modelFile.name,
                    }
                    // save file in firebase storage
                    await saveFile(
                        this.modelFile,
                        `${this.companyId}/settings/client_portal/models/${this.model.name}`,
                        file.id
                    )
                    const {
                        doubleAngleFile,
                        fpaFile,
                        cadFile,
                        specsFile,
                        installationManualFile,
                    } = await this.createFiles()
                    // save in db
                    const newModel = await API.createModel({
                        settingId: this.setting.id,
                        name: this.model.name,
                        file,
                        ...(doubleAngleFile ? { doubleAngleFile } : {}),
                        ...(fpaFile ? { fpaFile } : {}),
                        ...(cadFile ? { cadFile } : {}),
                        ...(specsFile ? { specsFile } : {}),
                        ...(installationManualFile
                            ? { installationManualFile }
                            : {}),
                    })
                    this.models.push(newModel)
                }
                this.closeDialog()
                this.model = {}
                this.modelFile = null
                this.doubleAngleFile = null
                this.fpaFile = null
                this.cadFile = null
                this.specsFile = null
                this.installationManualFile = null
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async downloadFileWithName(filePath, fileId, filename) {
            // Get download URL from Firebase Storage
            const storageRef = storage().ref(filePath)
            const documentRef = storageRef.child(fileId)
            const downloadURL = await documentRef.getDownloadURL()

            // Download file with custom name
            const response = await fetch(downloadURL)
            const blob = await response.blob()
            const url = window.URL.createObjectURL(blob)
            const link = window.document.createElement('a')
            link.href = url
            link.download = filename
            window.document.body.appendChild(link)
            link.click()
            window.document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
        },
        async openModelFile(item) {
            try {
                this.loading = true
                const filePath = `${this.companyId}/settings/client_portal/models/${item.name}`
                const filename = item.file.name || 'datasheet'
                await this.downloadFileWithName(
                    filePath,
                    item.file.id,
                    filename
                )
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async openFileByType(item, type) {
            try {
                this.loading = true

                // Map type to item property name
                const propertyMap = {
                    double_angle: 'doubleAngleFile',
                    fpa: 'fpaFile',
                    cad: 'cadFile',
                    specs: 'specsFile',
                    installation_manual: 'installationManualFile',
                }

                const propertyName = propertyMap[type]
                if (!propertyName || !item[propertyName]) {
                    throw new Error(`File type ${type} not found`)
                }

                const basePath = `${this.companyId}/settings/client_portal/models/${item.name}`
                const filePath = `${basePath}/${type}`
                const filename = item[propertyName].name || `file_${type}`

                await this.downloadFileWithName(
                    filePath,
                    item[propertyName].id,
                    filename
                )
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async getModels() {
            try {
                this.loading = true
                const allModels = await API.getModels({
                    settingId: this.setting.id,
                })
                //Filter for ACS models, those models are not louvers
                this.models = allModels.filter(
                    model => !model.modelType || model.modelType !== 'ACS'
                )
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
    },
}
</script>
